import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ea3a89d4")

_pushScopeId("data-v-ea3a89d4")
const _hoisted_1 = { class: "header row flex-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_3 = { class: "margin-right-5" }
const _hoisted_4 = { class: "el-dropdown-link flex-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("登出")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_menu, {
        "default-active": _ctx.activeIndex,
        class: "menu",
        mode: "horizontal"
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allowedMenus, (link, index) => {
            return (_openBlock(), _createBlock(_component_el_menu_item, {
              key: link.name,
              class: "font-20 font-bold",
              index: index + '',
              onClick: ($event: any) => (_ctx.goto(link.name))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(link.title), 1)
              ]),
              _: 2
            }, 1032, ["index", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["default-active"]),
      _hoisted_2,
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.user?.name || _ctx.user?.username), 1),
      _createVNode(_component_el_dropdown, null, {
        dropdown: _withId(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withId(() => [
              _createVNode(_component_el_dropdown_item, { onClick: _ctx.logout }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        default: _withId(() => [
          _createVNode("span", _hoisted_4, [
            _createVNode(_component_el_image, {
              src: _ctx.user?.avatar || _ctx.defaultAvatar,
              class: "avatar",
              fit: "cover"
            }, null, 8, ["src"]),
            _hoisted_5
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_divider, { class: "margin-bottom-10" }),
    _createVNode("div", null, [
      _createVNode(_component_router_view)
    ])
  ], 64))
})